import { useEffect, useState } from 'react'
import api, { ISpaceTypeWithCompany } from '@api'

interface IState {
  spaceType: ISpaceTypeWithCompany
  isLoading: boolean
  updateSpaceType: (spaceType: ISpaceTypeWithCompany) => void
}

export default function useSpaceType(id?: string): IState {
  const [isLoading, setIsLoading] = useState(true)
  const [spaceType, setSpaceType] = useState<ISpaceTypeWithCompany>({
    id: '',
    name: '',
    interactivityType: 0,
    displayName: '',
    company: null,
    hidden: false,
  })

  useEffect(() => {
    if (id) {
      api.space.spaceType.details(id).then((bt: ISpaceTypeWithCompany) => {
        setIsLoading(false)
        setSpaceType(bt)
      })
    }
  }, [id])

  return {
    spaceType,
    isLoading,
    updateSpaceType: (bt) => setSpaceType(bt),
  }
}
